import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import footerVenmo from "../components/img/footerVenmo.png";
import footerPaypal from "../components/img/footerPaypal.png";

function Copyright() {
  const year = new Date().getFullYear();
  return (
    <React.Fragment>
      <Typography>
        {`© ${year}`}
        <br />
        {'Watch Exchanger'}
      </Typography>
    </React.Fragment>
  );
}

const iconStyle = {
  width: 48,
  height: 48,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'warning.main',
  mr: 1,
  '&:hover': {
    bgcolor: 'warning.dark',
  },
};

export default function AppFooter() {
  return (
    <Typography
      component="footer"
      sx={{ display: 'flex', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ my: 8, display: 'flex' }}>
        <Grid container spacing={5}>
          <Grid item xs={6} sm={4} md={3}>
            <Grid
              container
              direction="column"
              justifyContent="flex-end"
              spacing={2}
              sx={{ height: 130 }}
            >
              <Grid item sx={{ display: 'flex' }}>
                <Box component="a" target="_blank" href="https://www.paypal.me/WatchExchanger" sx={iconStyle}>
                  <img
                    src={footerPaypal}
                    alt="Paypal"
                    width="65%"
                  />
                </Box>
                <Box component="a" target="_blank" href="https://www.venmo.com/WatchExchanger" sx={iconStyle}>
                  <img
                    src={footerVenmo}
                    alt="Venmo"
                    width="140%"
                  />
                </Box>
              </Grid>
              <Grid item>
                <Copyright />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <Typography variant="h6" marked="left" gutterBottom>
              Legal
            </Typography>
            <Box component="ul" sx={{ m: 0, listStyle: 'none', p: 0 }}>
              <Box component="li" sx={{ py: 0.5 }}>
                <Link href="/terms">Terms</Link>
              </Box>
              <Box component="li" sx={{ py: 0.5 }}>
                <Link href="/privacy">Privacy</Link>
              </Box>
              <Box component="li" sx={{ py: 0.5 }}>
                <Link href="mailto:help@watchexchanger.com">Contact Us</Link>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6} sm={8} md={4}>
          </Grid>
          <Grid item>
            <Typography variant="caption">
              {'Find this site useful? Consider making a donation wtih Paypal or Venmo by clicking the icons above.'}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}